import axiosConfig from '../modules/axiosConfig'
import utils from '../modules/utils'

const HTTP = axiosConfig.HTTP

const state = {
  code: '',
  loading: false,
  error: '',
  errorDescription: ''
}

// getters
const getters = {
  getlistCommercialData: (state) => state.code,
  isLoading: (state) => state.loading
}

// actions
const actions = {

  selectComercio: ({ commit }, comercio) => {
    commit('SET_UNIQUE_COMMERCE', comercio)
  },

  async listCommercial ({ commit, rootState }, data) {
    const config = rootState.appConfig.configFile

    try {
      const storageAppData = JSON.parse(sessionStorage.getItem('appParams'))
      const storageAppToken = sessionStorage.getItem('token')
      const hashToken = utils.SHA256(storageAppData.entidad + storageAppToken + storageAppData.canal)
      let codcadena = ''
      if (data !== undefined) {
        if (data.codcadenal !== undefined) {
          codcadena = data.codcadenal
        } else {
          codcadena = data
        }
      }
      let body = {}
      body = Object.assign({}, {
        runService: {
          opData: {
            avanzar: false,
            businesstimeout: '',
            canal: storageAppData.canal,
            claveFin: '',
            claveInicio: '',
            entidad: storageAppData.entidad,
            idioma: 'ES',
            indMasDatos: '',
            oficina: '',
            pantPagina: 0,
            retroceder: false,
            mainUser: storageAppData.mainUser,
            securityToken: hashToken
          },
          eEntrada: {
            codcadena: codcadena,
            codcom: ''
          }
        }
      })
      commit('LISTCOMMERCIAL_REQUEST_STARTED', true)
      const response = await HTTP.post(config.endpoints.listComercios, body)
      sessionStorage.setItem('token', response.data.runServiceResponse.return.securityToken)
      if (response.status === 200) {
        switch (response.data.runServiceResponse.return.retorno) {
          case '000':
            response.error = false
            commit('LISTCOMMERCIAL_REQUEST_SUCCEED', response.data.runServiceResponse.return)
            break
          case '039':
            response.error = true
            // commit('LISTCOMMERCIAL_REQUEST_FAILED', response.data.runServiceResponse.return)
            commit('HANDLE_ERROR', response.data.runServiceResponse.return.retorno, { root: true })
            return false
            // break
          case 200:
            response.error = true
            commit('LISTCOMMERCIAL_REQUEST_FAILED', response.data.runServiceResponse.return)
            break
          case 210:
            response.error = false
            commit('LISTCOMMERCIAL_REQUEST_FAILED', response.data.runServiceResponse.return)
            break
          case 220:
            response.error = true
            commit('LISTCOMMERCIAL_REQUEST_FAILED', response.data.runServiceResponse.return)
            break
          default:
            response.error = true
            commit('LISTCOMMERCIAL_REQUEST_FAILED', response.data.runServiceResponse.return)
            break
        }
      }
      commit('LISTCOMMERCIAL_REQUEST_FINISHED', false)
      return response
    } catch (error) {
      return error
    }
  },
  loader ({ commit }, actions) {
    commit('SET_LOADER', actions)
  }
}

// mutations
const mutations = {
  'SET_LOADER' (state, actions) {
    state.loading = actions.loader === true
    state.isPasswordText = actions.password === true
  },
  'LISTCOMMERCIAL_REQUEST_STARTED' (state, payload) {
    state.loading = payload
  },
  'LISTCOMMERCIAL_REQUEST_EMPTY' (state, payload) {
    const datos = payload
    state.error = false
    state.errorDescription = ''
    state.code = datos.totalRegistros > 1 ? datos.registros : Array(datos.registros)
  },
  'LISTCOMMERCIAL_REQUEST_FINISHED' (state, payload) {
    state.loading = payload
  },
  'LISTCOMMERCIAL_REQUEST_SUCCEED' (state, payload) {
    const datos = payload
    state.error = false
    state.errorDescription = ''
    state.code = datos.totalRegistros > 1 ? datos.registros : Array(datos.registros)
  },
  'SET_UNIQUE_COMMERCE' (state, payload) {
    const datos = payload
    state.error = false
    state.errorDescription = ''
    state.code = Array(datos)
  },
  'LISTCOMMERCIAL_REQUEST_FAILED' (state, payload) {
    if (payload.retorno === 200) {
      state.errorDescription = 'Error ejecución de servicio'
    } else if (payload.retorno === 220) {
      state.errorDescription = 'Error técnico'
    } else if (payload.retorno === '039') {
      state.errorDescription = 'Sesión expirada'
    } else if (payload.retorno === 210) {
      state.errorDescription = 'No se encontraron datos para los criterios de selección'
    }
    state.error = true
    state.code = ''
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
